// extracted by mini-css-extract-plugin
export default {"JobFormSteps":"styles_JobFormSteps__PGaLc","active":"styles_active__heDwc","stepNumber":"styles_stepNumber__VMGQn","title":"styles_title__NyNio","details":"styles_details__lJuLj"};